// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/spin/style/index.less
// module id = 1069
// module chunks = 1